import { formatCents, parseCents, periodLabel, MONTH_NAMES_ES, dateLabel, shortDateLabel } from '@balance/domain';
export { formatCents, parseCents, periodLabel, dateLabel, shortDateLabel };

export function eur(cents: number | null | undefined, options?: { sign?: boolean }): string {
  if (cents === null || cents === undefined) return '—';
  return formatCents(cents, options);
}

/** Céntimos → texto editable "123,45". */
export function centsToInput(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '';
  const abs = Math.abs(cents);
  return `${cents < 0 ? '-' : ''}${Math.floor(abs / 100)},${String(abs % 100).padStart(2, '0')}`;
}

export function inputToCents(text: string): number | null {
  if (text.trim() === '') return null;
  try {
    return parseCents(text);
  } catch {
    return null;
  }
}

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function monthName(period: string): string {
  const m = Number(period.slice(5, 7));
  return MONTH_NAMES_ES[m - 1] ?? period;
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return new Intl.DateTimeFormat('es-ES', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Madrid' }).format(d);
}
